// services/ugc/endpoints.ts

export const UGC_ENDPOINTS = {
  testimonies: {
    root: "/posts/testimonies",
    me: "/posts/testimonies/me",
    feed: "/posts/testimonies/feed",
    explore: "/posts/testimonies/explore",

    // semantic helpers
    listen: (slug: string) => `/posts/testimonies/${slug}`,
    detail: (slug: string) => `/posts/testimonies/${slug}`,
  },

  moments: {
    root: "/posts/moments",
    feed: "/posts/moments/feed",
    explore: "/posts/moments/explore",
    detail: (slug: string) => `/posts/moments/${slug}`,
  },

  prayers: {
    root: "/posts/prayers",
    feed: "/posts/prayers/feed",
    explore: "/posts/prayers/explore",
    detail: (slug: string) => `/posts/prayers/${slug}`,
  },
} as const;
